/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementGenerateZipCertResponse } from './LiveManagementGenerateZipCertResponse';

export type LiveManagementGenerateZipCertResponseApiRespoonse = {
    data?: LiveManagementGenerateZipCertResponse;
    status?: LiveManagementGenerateZipCertResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace LiveManagementGenerateZipCertResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

